import { apiToken, getIntegrationUrl, registerIntegrationUrl } from "../config"


// Register Integration Start
export const registerIntegration = async (data) => {
    try {
        const response = await fetch(registerIntegrationUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify(data)
        });
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Network response was not ok")
        }
        return res.message;
    } catch(e) {
        throw new Error(e.message || "Please try again")
    }
}

// Register integrations end

// get all organisation Integrations with orgid start

export const getOrganisationIntegrations = async (orgId) => {
    try {
        const uri = `${getIntegrationUrl}?organizationId=${orgId}`;
        const response = await fetch(uri, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        })
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Network response was not ok")
        }
        return res;

    } catch(e) {
        throw new Error(e.message || "Please try again")
    }
}

// get all organisation integrations with orgid end

// get all integrations start

export const getAllIntegrations = async (params={}) => {
    try {
        const url = new URL(getIntegrationUrl);
        const query = {
            page: params.page || 1,
            limit: params.limit || 10,
        }
        Object.keys(query).forEach((key) => {
            if (query[key]) url.searchParams.append(key, query[key]);
        });
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        })
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || 'Network response was not ok')
        }
        return res;

    } catch (e) {
        throw new Error(e.message || 'Please try again later')
    } 
}

// get all Integrations end

// to Delete an integration start

export const deleteIntegrationsWithId = async (integrationId) => {
    try {
        const uri = `${getIntegrationUrl}/${integrationId}`;
        const response = await fetch(uri, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        })
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Network response was not ok")
        }
        return res;
    } catch(e) {
        throw new Error(e.message || "Please try again")
    }
}

// to delete an integration end

// get Integration with integrationId start

export const getIntegrationsWithId = async (integrationId) => {
    try {
        const uri = `${getIntegrationUrl}/${integrationId}`;
        const response = await fetch(uri, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        })
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Network response was not ok")
        }
        return res;

    } catch(e) {
        throw new Error(e.message || "Please try again")
    }
}

// get integration with integrationId end

// update the integration data with id

export const updateIntegrationWithId = async (integrationId, data) => {
    try {
        const response = await fetch(`${getIntegrationUrl}/${integrationId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify(data)
        });
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Network response was not ok")
        }
        return res;
    } catch(e) {
        throw new Error(e.message || 'Please try again later');
    }
}

// update the integration data with id